import React from "react";

export default function Spacer({ height = "10vh" }) {
  return <div style={{ height, minWidth: "100%" }} />;
}
